import { CONTENT_TYPES } from 'constants/games/contentTypes'

import { LeverageGamesJumboCSS } from './LeverageGamesJumboCSS.styled'
import { useNavigate } from 'react-router-dom'

export const LeverageGamesJumbo = () => {
  const navigateTo = useNavigate()
  const handleCryptoClick = (e) => {
    e.stopPropagation()
    navigateTo(`/game/${CONTENT_TYPES.LVG_CRYPTO}`)
  }
  const handleStocksClick = (e) => {
    e.stopPropagation()
    navigateTo(`/game/${CONTENT_TYPES.LVG_STOCKS}`)
  }
  const handleIndexesClick = (e) => {
    e.stopPropagation()
    navigateTo(`/game/${CONTENT_TYPES.LVG_INDEXES}`)
  }
  return (
    <LeverageGamesJumboCSS onClick={handleCryptoClick}>
      <div className='game_box infinite_winnings'>
        <div className='top'>
          <div className='feature_bid-cloning'>
            <p>
              Now with <strong>BID CLONING</strong>
            </p>
            <div className='bid_cloning_icon'></div>
          </div>
        </div>
        <div className='bottom'>
          <div className='left'>
            <p>
              This is the next-degen <span>leveraged gaming experience</span> with the insanely good design and
              performance that you´ve been craving. It’s got killer leverage, incentives, royalties, and leverage up-to
              1000x with no minimum portfolio balance.
            </p>
          </div>
          <div className='right'>
            <button className='crypto' onClick={handleCryptoClick}>
              Leveraged <strong>Crypto</strong>
            </button>
            {/* <button className='stocks' onClick={handleStocksClick}>
              Leveraged <strong>Synthetic Stocks</strong>
            </button> */}
            <button className='indexes' onClick={handleIndexesClick}>
              Leveraged <strong>Indexes</strong>
            </button>
          </div>
        </div>
      </div>
    </LeverageGamesJumboCSS>
  )
}
